import React from 'react';
import { VideoFramesApi, ScriptsApi } from 'Api';
import { Recorder as RecorderComponent } from 'react-cam-recorder';
import './index.css';

const framesSource = async (offset, limit) => {
  const { data } = await VideoFramesApi.list(offset, limit);
  return data.map(({ id, title, imageSource }) => ({
    id,
    url: imageSource,
    title,
  }));
};

class Recorder extends React.Component {
  state = { hasFrames: null, selectedFrame: null };
  detectHasFrames = async () => {
    const { count } = await VideoFramesApi.list(0, 0);
    this.setState({ hasFrames: count > 0 });
  };
  componentDidMount() {
    this.detectHasFrames();
  }

  onVideoReady = (video) => {
    const { onVideoReady } = this.props;
    const { selectedFrame } = this.state;
    return onVideoReady(video, selectedFrame);
  };

  render() {
    // eslint-disable-next-line
    const { onVideoReady, ...props } = this.props;
    const { hasFrames } = this.state;

    if (hasFrames === null) {
      return null;
    }

    return (
      <RecorderComponent
        {...{
          ...props,
          onVideoReady: this.onVideoReady,
          framesSource: hasFrames ? framesSource : null,
          onFrameChange: (frame) => this.setState({ selectedFrame: frame }),
          assistScriptGeneration: (instruction, history = []) =>
            ScriptsApi.generate(instruction, history),
        }}
      />
    );
  }
}

export default Recorder;
